import { render, staticRenderFns } from "./PrepaidGroups.vue?vue&type=template&id=8db48bb4&"
import script from "./PrepaidGroups.vue?vue&type=script&lang=js&"
export * from "./PrepaidGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports